<template>
  <div>
    <van-nav-bar title="用户信息" />
    <van-form @submit="onSubmit">
<!--      <van-image-->
<!--          round-->
<!--          width="10rem"-->
<!--          height="10rem"-->
<!--          :src="`${userInfo.avatar}`"-->
<!--      />-->
      <van-field
          v-model="userInfo.userName"
          name="登录账号"
          label="登录账号"
          disabled
          placeholder="登录账号"
      />
      <van-field
          v-model="userInfo.nickName"
          name="用户昵称"
          label="用户昵称"
          disabled
          placeholder="用户昵称"
      />
      <van-field
          v-model="userInfo.phonenumber"
          name="手机号码"
          label="手机号码"
          disabled
          placeholder="手机号码"
      />
      <van-field
          name="公司/部门"
          label="公司/部门"
          disabled
          placeholder="公司/部门"
          type="textarea"
      >
        <template #input>
          <div v-for="item in userInfo.deptNames">{{item}}</div>
        </template>
      </van-field>

      <div style="margin: 16px;">
        <van-button round block type="warning" native-type="submit" @click="resetPwd">重置密码</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import {resetUserPwd} from "@/api/user";
import cache from "@/plugins/cache";
export default {
  data() {
    return {
      userInfo:{}
    }
  },
  created() {
    this.userInfo = JSON.parse(cache.session.get('userInfo'))
  },
  methods: {
    resetPwd() {
      this.$dialog.confirm({
        title: '提示',
        message: '确定重置密码吗？重置后密码为123456',
      }).then(() => {
        resetUserPwd(this.userInfo.userId, '123456').then(res => {
          if (res.code === 200) {
            this.$toast('重置成功');
          } else {
            this.$toast(res.msg);
          }
        })
      })
    }
  }
}

</script>
<style scoped>
/deep/ .van-field__control--custom{
  flex-direction: column;
}
/deep/ .van-field--min-height .van-field__control{
  min-height: 0
}
</style>
